export const environment = {
    production: true,
    //apiUrl: 'https://uatapi.splsecurities.com'
    //apiUrl: 'http://localhost:3000'
    apiUrl: 'https://api.bjxsecurities.com'
};
